import React from "react";
import { connect } from "react-redux";

import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tag from "antd/es/tag";
import { useIntl } from "react-intl";

import { isEmailServiceSupported } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./EmailSubscriptionStatus.module.scss";
import messages from "./messages";

interface EmailSubscriptionStatusTagProps {
  className?: string;
  emailServiceSupported: boolean;
  emailSubscribed: boolean;
}

const EmailSubscriptionStatusTag: React.FC<EmailSubscriptionStatusTagProps> = ({
  className,
  emailSubscribed,
}) => {
  const intl = useIntl();

  if (!isEmailServiceSupported || emailSubscribed) {
    return null;
  }

  return (
    <Tag className={className}>
      <FontAwesomeIcon className={styles.icon} icon={faEnvelope} />
      <span>{intl.formatMessage(messages.unsubscribedLabel)}</span>
    </Tag>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailServiceSupported: isEmailServiceSupported(state),
});

export default connect(mapStateToProps)(EmailSubscriptionStatusTag);
